import { defineComponent, computed, h, openBlock, createElementBlock, withKeys, withModifiers, normalizeStyle, normalizeClass, createElementVNode, createBlock, resolveDynamicComponent, createCommentVNode, toDisplayString, createVNode, unref } from "vue";
import CloseIcon from "../../assets/icons/x-close.svg.js";
const _hoisted_1 = ["role", "tabindex"];
const _hoisted_2 = { class: "notification__upper" };
const _hoisted_3 = { class: "notification__icon" };
const _hoisted_4 = {
  key: 0,
  class: "notification__text"
};
const _hoisted_5 = { class: "notification__title" };
const _hoisted_6 = {
  key: 0,
  class: "notification__content"
};
const _hoisted_7 = {
  key: 1,
  class: "notification__additional-content"
};
const _hoisted_8 = {
  key: 0,
  class: "notification__lower notification__text"
};
const _hoisted_9 = { class: "notification__title" };
const _hoisted_10 = {
  key: 0,
  class: "notification__content"
};
const _hoisted_11 = {
  key: 1,
  class: "notification__additional-content"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Notification",
  props: {
    type: { default: "toast" },
    status: { default: "NEUTRAL" },
    position: { default: "top-middle" },
    text: { default: "" },
    isDismissing: { type: Boolean, default: false },
    icon: { type: [Object, Function], default: void 0 },
    additionalContent: { type: [Object, Function], default: void 0 },
    showCloseIcon: { type: Boolean, default: true },
    clickable: { type: Boolean, default: false },
    rounded: { default: void 0 }
  },
  emits: ["transitionend", "close", "click"],
  setup(__props) {
    const props = __props;
    const rootStyle = computed(() => props.rounded ? { "border-radius": `var(--radius-${props.rounded})` } : void 0);
    const renderIcon = computed(() => {
      if (!props.icon) return null;
      if (typeof props.icon === "function") {
        return props.icon();
      }
      if (typeof props.icon === "object" && "type" in props.icon) {
        return props.icon;
      }
      return h(props.icon);
    });
    const renderAdditionalContent = computed(() => {
      if (!props.additionalContent) return null;
      if (typeof props.additionalContent === "function") {
        return props.additionalContent();
      }
      if (typeof props.additionalContent === "object" && "type" in props.additionalContent) {
        return props.additionalContent;
      }
      return h(props.additionalContent);
    });
    const notificationTitle = computed(() => {
      return typeof props.text === "string" ? props.text : props.text.title;
    });
    const notificationContent = computed(() => {
      return typeof props.text === "string" ? void 0 : props.text.content;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "notification",
          `notification--type-${__props.type}`,
          `notification--status-${__props.status}`,
          `notification--position-${__props.position}`,
          { "notification--dismiss": __props.isDismissing },
          { "notification--clickable": __props.clickable }
        ]),
        style: normalizeStyle(rootStyle.value),
        role: __props.clickable ? "button" : void 0,
        tabindex: __props.clickable ? 0 : void 0,
        onTransitionend: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("transitionend")),
        onClick: _cache[2] || (_cache[2] = ($event) => __props.clickable && _ctx.$emit("click")),
        onKeydown: [
          _cache[3] || (_cache[3] = withKeys(withModifiers(($event) => __props.clickable && _ctx.$emit("click"), ["prevent"]), ["enter"])),
          _cache[4] || (_cache[4] = withKeys(withModifiers(($event) => __props.clickable && _ctx.$emit("click"), ["prevent"]), ["space"]))
        ]
      }, [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            renderIcon.value ? (openBlock(), createBlock(resolveDynamicComponent(renderIcon.value), { key: 0 })) : createCommentVNode("", true)
          ]),
          __props.type !== "notification" ? (openBlock(), createElementBlock("div", _hoisted_4, [
            createElementVNode("div", _hoisted_5, toDisplayString(notificationTitle.value), 1),
            notificationContent.value ? (openBlock(), createElementBlock("div", _hoisted_6, toDisplayString(notificationContent.value), 1)) : createCommentVNode("", true),
            renderAdditionalContent.value ? (openBlock(), createElementBlock("div", _hoisted_7, [
              (openBlock(), createBlock(resolveDynamicComponent(renderAdditionalContent.value)))
            ])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          __props.showCloseIcon ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "notification__close",
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("close"), ["stop"]))
          }, [
            createVNode(unref(CloseIcon))
          ])) : createCommentVNode("", true)
        ]),
        __props.type === "notification" ? (openBlock(), createElementBlock("div", _hoisted_8, [
          createElementVNode("div", _hoisted_9, toDisplayString(notificationTitle.value), 1),
          notificationContent.value ? (openBlock(), createElementBlock("div", _hoisted_10, toDisplayString(notificationContent.value), 1)) : createCommentVNode("", true),
          renderAdditionalContent.value ? (openBlock(), createElementBlock("div", _hoisted_11, [
            (openBlock(), createBlock(resolveDynamicComponent(renderAdditionalContent.value)))
          ])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ], 46, _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Notification.vue2.js.map
